import axiosClient from '../axiosClient';

export interface ColumnOrdinalUpdate {
  columnName: string;
  ordinal: number;
}

export interface ReorderColumnsRequest {
  columns: ColumnOrdinalUpdate[];
}

/**
 * Reorder database object columns in a single batch operation.
 * This is more efficient and deadlock-safe than updating columns individually.
 *
 * @param databaseObjectId - The database object ID
 * @param columns - Array of columns with their new ordinal values
 */
export async function reorderDatabaseObjectColumns (
  databaseObjectId: number,
  columns: ColumnOrdinalUpdate[]
): Promise<void> {
  const request: ReorderColumnsRequest = { columns };
  await axiosClient.post(
    `/v2/database/object/${databaseObjectId}/columns/reorder`,
    request
  );
}

export interface BatchColumnUpdate {
  columnName: string;
  // DatabaseObject-kolonner (alle nullable for partial updates)
  showInList?: boolean | null;
  showInDetail?: boolean | null;
  includeInExport?: boolean | null;
  isReadOnly?: boolean | null;
  columnWidth?: number | null;
  ordinal?: number | null;
  componentEdit?: string | null;
  // TableDefinition IncludeInputFormNew (kun for table-kolonner)
  includeInputFormNew?: boolean | null;
}

export interface BatchUpdateColumnsRequest {
  databaseObjectId: number;
  columns: BatchColumnUpdate[];
}

/**
 * Batch update database object columns in a single transaction.
 * Handles both DatabaseObject columns and TableDefinition IncludeInputFormNew.
 * This is more efficient and transactionally safe than updating columns individually.
 *
 * @param databaseObjectId - The database object ID
 * @param columns - Array of column updates (all fields nullable for partial updates)
 */
export async function batchUpdateDatabaseObjectColumns (
  databaseObjectId: number,
  columns: BatchColumnUpdate[]
): Promise<void> {
  const request: BatchUpdateColumnsRequest = {
    databaseObjectId,
    columns
  };
  await axiosClient.post(
    `/v2/database/object/${databaseObjectId}/columns/batch`,
    request
  );
}

